'use client'

import { useState } from "react";
import ThemeSearch from "./ThemeSearch";
import ThemeScroll from "./ThemeScroll";
import Modal from "@/components/Modal/Modal";
import ThemeForm from "./ThemeForm";

const ThemeListView = () => {
    const [filter, setFilter] = useState('');
    const [orderBy, setOrderBy] = useState<boolean>(false);
    const [isAddPriceModalOpen, setIsAddPriceModalOpen] = useState(false);
    
    const handleOnSearch = (value: string) => {
      setFilter(value);
    }

    const closeModal = () => {
        setIsAddPriceModalOpen(false);
    }

    return (
        <div>
            <Modal isOpen={isAddPriceModalOpen} onClose={() => closeModal()}  title={"Theme"}>
                <ThemeForm closeModal={closeModal}/>
            </Modal>
            <ThemeSearch
                onSearch={handleOnSearch}
                onOrderChange={() => setOrderBy(prev => !prev)}
            />
            <ThemeScroll
                filter={filter}
                orderByDate={orderBy}
                reloadThemeList={isAddPriceModalOpen}
            />
        </div>
    )
}

export default ThemeListView;
